/*
 * Pets Garden — carosello prodotti della home ("Special category" con schede
 * Cane / Gatto / Accessori). Non modifica il codice della sezione del tema:
 * agisce sui caroselli già creati.
 * - aggiunge le frecce ai lati (desktop), una coppia per scheda;
 * - con pochi prodotti (es. Accessori) centra le card e nasconde le frecce.
 */
(function () {
  var FRECCIA = {
    prev: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  };

  function bottone(verso, swiper) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pg-car-btn pg-car-' + verso;
    b.setAttribute('aria-label', verso === 'prev' ? 'Prodotti precedenti' : 'Prodotti successivi');
    b.innerHTML = FRECCIA[verso];
    b.addEventListener('click', function () {
      if (verso === 'prev') swiper.slidePrev(); else swiper.slideNext();
    });
    return b;
  }

  function prepara(el) {
    var swiper = el.swiper;
    if (!swiper || el.dataset.pgCarosello) return;
    el.dataset.pgCarosello = '1';

    swiper.params.centerInsufficientSlides = true;
    swiper.update();

    var contenitore = el.parentElement;
    contenitore.classList.add('pg-carosello');
    var prev = bottone('prev', swiper);
    var next = bottone('next', swiper);
    contenitore.appendChild(prev);
    contenitore.appendChild(next);

    function stato() {
      var tutto = swiper.isBeginning && swiper.isEnd; // tutti i prodotti già visibili
      prev.hidden = next.hidden = tutto;
      prev.disabled = swiper.isBeginning;
      next.disabled = swiper.isEnd;
    }
    ['slideChange', 'resize', 'update', 'observerUpdate', 'reachEnd', 'reachBeginning'].forEach(function (ev) {
      swiper.on(ev, stato);
    });
    stato();
  }

  function avvia(tentativi) {
    var sliders = document.querySelectorAll('.special-slider.swiper');
    var pronti = 0;
    sliders.forEach(function (el) {
      if (el.swiper) { prepara(el); pronti++; }
    });
    // I caroselli vengono creati dal tema al DOMContentLoaded: se non sono ancora pronti, riprova
    if (pronti < sliders.length && tentativi > 0) setTimeout(function () { avvia(tentativi - 1); }, 200);
  }

  document.addEventListener('DOMContentLoaded', function () { setTimeout(function () { avvia(10); }, 0); });
})();
